import React from 'react';
import { User } from '../../../hooks/useUsersManagement';
import EditUserModal from '../EditUserModal';
import CreateUserModal from '../CreateUserModal';

interface UserModalsProps {
  isEditModalOpen: boolean;
  isCreateModalOpen: boolean;
  selectedUser: User | null;
  onCloseEditModal: () => void;
  onCloseCreateModal: () => void;
  onUserCreated: () => void;
  onUserUpdated: () => void;
}

const UserModals: React.FC<UserModalsProps> = ({
  isEditModalOpen,
  isCreateModalOpen,
  selectedUser,
  onCloseEditModal,
  onCloseCreateModal,
  onUserCreated,
  onUserUpdated
}) => {
  return (
    <>
      {/* Edit User Modal */}
      <EditUserModal
        open={isEditModalOpen}
        onClose={onCloseEditModal}
        user={selectedUser}
        onUserUpdated={onUserUpdated}
      />
      
      {/* Create User Modal */}
      <CreateUserModal
        open={isCreateModalOpen}
        onClose={onCloseCreateModal}
        onUserCreated={onUserCreated}
      />
    </>
  );
};

export default UserModals;